import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'number-11-small', 'IconNumber11Small', [["path",{"d":"M8 10l2 -2v8","key":"svg-0"}],["path",{"d":"M14 10l2 -2v8","key":"svg-1"}]]);